import { AddExistingPoint, AddPoint, AddTrace } from "../Util/ActivitesUtil";

import $ from "jquery";

import uniqid from 'uniqid';
import { ExportPdf } from "./ExportUtil";

/* SaveTemplate is call by frequence id App.tsx and on click on Header.tsx */
function SaveTemplate(context: any) {

    const { mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock, jsonFormat } = context;

    const queryParameters = new URLSearchParams(window.location.search);

    /* mapListPoint => on retire les elements avec function (marker...) */
    var copymapListPoint: any[] = [];
    if (mapListPoint != undefined) {
        copymapListPoint = [];

        mapListPoint.forEach((element: any) => {
            var copyElem = { ...element }
            copyElem.marker = null; copyElem.markerTxt = null;
            copymapListPoint.push(copyElem);
        });
    }

    /* objItems => on retire les elements avec function (rnd...) */
    var copyTextItems: any[] = []

    if (objItems != undefined) {
        copyTextItems = [];
        objItems.forEach((element: any) => {
            var copyElemText = { ...element }
            if (copyElemText.rnd != null) copyElemText.rnd = null;
            if (copyElemText.rndClone != null) copyElemText.rndClone = null;
            copyTextItems.push(copyElemText)
        });
    }

    var map = (window as any).$map;

    var exportJSON = {
        "idProduct": queryParameters.get("productId"),
        "pageSize": pageSize,
        "isPortrait": isPortrait,
        "pageColor": pageColor,
        "mapPosition": mapPosition,
        "mapIndex": mapIndex,
        "mapTaille": mapTaille,
        "mapUrlStyle": mapUrlStyle,
        "objItems": copyTextItems,
        "mapListPoint": copymapListPoint,
        "mapListTrace": mapListTrace,
        "mapZoom": map.getZoom(),
        "mapCenter": map.getCenter(),
        "mapBearing": map.getBearing(),
        "mapPitch": map.getPitch(),
        "elevationData": elevationData,
        "setIsMode3D": isMode3D,
        "mapLock": mapLock,
        "jsonFormat" : jsonFormat
    }

    return exportJSON;

}

function LoadTemplate(val: any, context: any, withTrace: boolean) {

    const { setObjItems,
        mapListPoint, addMapListPoint,
        mapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad,
        setPageSize,
        setPageColor,
        setMapPosition, setMapIndex,
        setMapTaille,
        setMapUrlStyle, setElevationData, setIsElevationPresent, setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter } = context;

    //Gestion de la page : taille et couleur
    if (setPageSize != null) setPageSize(val.pageSize);
    if (setJsonFormat != null && val.jsonFormat != null) setJsonFormat(val.jsonFormat);
    if (setIsPortrait != null) setIsPortrait(val.isPortrait != undefined ? val.isPortrait : true)
    if (setPageColor != null) setPageColor(val.pageColor);

    if (setMapLock != null) setMapLock(val.mapLock);
    //if (val.mapLock != null && val.mapLock) $('.map-element').css('pointer-events', 'none');

    //Gestion de la map : position et taille et theme, ZOOM TODO!!
    if (setMapPosition != null) setMapPosition(val.mapPosition)
    if (setMapTaille != null) setMapTaille(val.mapTaille)
    if (setMapIndex != null) setMapIndex(val.mapIndex != undefined ? val.mapIndex : 0)

    if (setMapUrlStyle != null) setMapUrlStyle(val.mapUrlStyle)
    var map = (window as any).$map;
    map.setStyle(val.mapUrlStyle);

    if (val.mapZoom != null || val.mapZoom != undefined) {
        map.setZoom(val.mapZoom);
        if (setMapZoom != null) setMapZoom(val.mapZoom);
    
    };
    if (val.mapCenter != null || val.mapCenter != undefined) {
        map.setCenter(val.mapCenter);
        if (setMapCenter != null) setMapCenter(val.mapCenter);
    }

    if (val.elevationData != null) setElevationData(val.elevationData)

    // Gestion des éléments
    if (setObjItems != null && val.objItems != undefined) {

        //on change l'id pour for le rechargement des éléments
        val.objItems.forEach((element: any) => {
            element.id = uniqid();
        });

        //on copie tous sauf des crop-cadre-element (possiblement présent si sauvegarde avec crop element ouvert)
        setObjItems(val.objItems.filter((item :any) => item.type !== "crop-cadre-element"));

        var elevationCart = val.objItems.find((item: any) => item.class === 'elevation-element');
        if (elevationCart != null) setIsElevationPresent(true);
    }

    if (val.mapBearing != null) map.setBearing(val.mapBearing);
    if (val.mapPitch != null) map.setPitch(val.mapPitch);

    var listPoint, listTrace;

    if (withTrace) { listPoint = val.mapListPoint; listTrace = val.mapListTrace }
    else { listPoint = mapListPoint; listTrace = mapListTrace }

    //on a besoin d'un délai après changer le style
    setTimeout(() => {
        //TO DO JUST AFTER
        //Gestion des points GPS
        /* On peut pas se permettre de gérer les traces comme les objets dans des listes, au risque de recharger les tracés très souvent*/
        const copyItemsPoint: any[] = [];
        val.mapListPoint.forEach((element: any) => {
            var newPoint = AddExistingPoint(element, false, { mapListPoint, addMapListPoint });
            copyItemsPoint.push(newPoint);
        });

        if (addMapListPoint != null) addMapListPoint(copyItemsPoint);

        //Gestion des tracés

        /* supprimer les tracés existants ? */
        /* NON, car utilisateur veut ses propres tracés */
        /* On peut pas se permettre de gérer les traces comme les objets dans des listes, au risque de recharger les tracés très souvent*/
        const copyItemsTrace: any[] = [];
        val.mapListTrace.forEach((element: any) => {
            var newTrace = AddTrace(element.name, element.sourceData, element.sourceData, element.type, element.point1, element.point2, element.id, element.traceStyle,
                { addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTraceSpecialFirtstLoad });

            copyItemsTrace.push(newTrace)
        });

        if (addMapListTraceSpecialFirtstLoad != null) addMapListTraceSpecialFirtstLoad(copyItemsTrace, val.elevationData);

        // Passage map en mode 3D
        if (val.setIsMode3D != null) {

            if (val.setIsMode3D == true) {

                map.addSource('mapbox-dem', {
                    'type': 'raster-dem',
                    'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
                    'tileSize': 512,
                    'maxzoom': 14
                });
                // add the DEM source as a terrain layer with exaggerated height
                map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2 });

                if (setIsMode3D) setIsMode3D(true);

            } else {
                if (setIsMode3D) setIsMode3D(false);
            }

        }

    }, 1500);

}

function LoadTemplateJustModele(val: any, context: any, withTrace: boolean) {

    const { setObjItems,
        mapListPoint, addMapListPoint,
        mapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad,
        setPageSize,
        setPageColor,
        setMapPosition,
        setMapTaille,
        setMapUrlStyle, setElevationData, setIsElevationPresent, setIsMode3D, setIsPortrait, setMapLock,
        mapSources, mapLayers } = context;

    if (setPageColor != null) setPageColor(val.pageColor);

    //Gestion de la map : position et taille et theme, ZOOM TODO!!
    if (setMapPosition != null) setMapPosition(val.mapPosition)
    //if (setMapTaille != null) setMapTaille(val.mapTaille)

    if (setMapUrlStyle != null) setMapUrlStyle(val.mapUrlStyle)
    var map = (window as any).$map;
    setTimeout(() => {
        map.setStyle(val.mapUrlStyle);
    }, 200);

    if (val.elevationData != null) setElevationData(val.elevationData)

    // Gestion des éléments
    if (setObjItems != null && val.objItems != undefined) {

        //on change l'id pour for le rechargement des éléments
        val.objItems.forEach((element: any) => {
            element.id = uniqid();
        });

        setObjItems(val.objItems);

        var elevationCart = val.objItems.find((item: any) => item.class === 'elevation-element');
        if (elevationCart != null) setIsElevationPresent(true);
    }

    //if (val.mapBearing != null) map.setBearing(val.mapBearing);
    //if (val.mapPitch != null) map.setPitch(val.mapPitch);

    if (setMapTaille != null) setMapTaille(val.mapTaille)

    //on a besoin d'un délai après changer le style
    setTimeout(() => {

        var source = mapSources;
        var layer = mapLayers;

        /**/if (mapSources != undefined) {
            for (var i = 0; i < source.length; i++) {

                var sourceData = mapListTrace.find((elem: any) => elem.id === source[i].id);

                map.addSource(source[i].id, {
                    type: "geojson",
                    data: sourceData.sourceData,

                });
                map.addLayer({
                    id: layer[i].id,
                    type: layer[i].type,
                    source: layer[i].source,
                    layout: {
                        // get the title name from the source's "title" property
                        //"text-field": ['get', 'title'],
                    },
                    paint: sourceData.traceStyle//layer[i].paint
                })

            }
        }

        /**/if (val.setIsMode3D != null && val.setIsMode3D == true) {

            map.addSource('mapbox-dem', {
                'type': 'raster-dem',
                'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
                'tileSize': 512,
                'maxzoom': 14
            });
            // add the DEM source as a terrain layer with exaggerated height
            map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2 });

        }

    }, 1500);
}

export { SaveTemplate, LoadTemplate, LoadTemplateJustModele };